import { Link } from 'react-router-dom';
import moment from 'moment';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ICONS, PATHS } from '../../common/constants';
import { selectSearch } from '../../store/selectors/search';
import IcoMoon from '../IcoMoon';
import Label from '../Label';
import Status from '../Status';
import Table from '../Table';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectLoader } from '../../store/selectors/loader';
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';

class ReportingUserActivityTable extends Component {

  state = {
    hasMoreRecords: true,
  }

  render() {
    const { reports} = this.props;
    return (
      <>       

        {reports && reports.length > 0 ? (
          <>
             {this.props.formLoader ?
               <div style={{justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                <Loader loading={true} center={true}/>
                </div>
                : null}
            <div
              id="scrollableDiv"
              style={{
                height: 500,
                overflow: "auto",
                display: "flex",
                flexDirection: "column"
              }}
            >
                         
              <InfiniteScroll
                dataLength={reports.length}
                style={{ display: "flex", flexDirection: "column" }}
                inverse={false}
                scrollableTarget="scrollableDiv"
              >
                <Table
                  columns={[
                    {
                      // xsHide: true,
                      sortable: true,
                      label: 'User/Account',
                      cell: data => {
                      return (
                      //   <Link
                      //   to={{pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(':id', data.id), 
                      //     state: { navigateTo: this.props.navigateTo}      
                      // }}
                      // >
                      data.userName
                      // </Link>
                      )
                    }
                    },
                    {
                      label: 'Date',
                      accessor: 'number',
                      cell: data => {
                        return (
                        data.date
                        )
                      }
                    },
                  
                     {
                      label: 'Event',
                      cell: data => data.event
                    },
                    {
                      label: 'Time',
                      cell: data => (
                        data.time
                      )
                    },
                    {
                      xsHide: true,
                      label: 'Session Time(HH:MM:SS)',
                      cell: data => (<>{data.sessionTime}</>
                        // data.event === 'Logout' ? moment(data.date).format('hh:mm A') : null
                      )
                    }
                  ]}
                  data={reports}
                />
              </InfiniteScroll>
            </div>
          </>
        ) : (
            null
          )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  search: selectSearch(state),
  user: selectAuthenticatedUser(state),
  loader: selectLoader(state),
  formLoader: selectFormLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReportingUserActivityTable);
